import React from 'react';
import ScrollAnimation from "react-animate-on-scroll";


const BenefitSection = ({number,title, description, image}) => {
    return (
        <div className='section-title'>
            <div className="about-area about-style-4">
                <div className="container">
                    <div className="row row--40 align-items-left pt-5 pb-5">
                        <div className="col-lg-6 mt_md--40 mt_sm--40"  style={{marginTop:"auto",marginBottom:"auto"}}>
                            <ScrollAnimation 
                                animateIn="fadeInLeft"
                                animateOut="fadeInOut"
                                animateOnce={true}>
                            <div className="content">
                                <div className="inner">
                                    <div className='d-flex benefit-responsive'>
                                        <h3 className="title custom-title theme-gradient" dangerouslySetInnerHTML={{__html: number}}></h3><h4 className='title-benefit'><span dangerouslySetInnerHTML={{__html: title}}></span></h4>
                                    </div>
                                    <ul className="feature-list">
                                        <li dangerouslySetInnerHTML={{__html: description}}></li>
                                    </ul>
                                </div>
                            </div>
                            </ScrollAnimation>
                        </div>

                        <div className="col-lg-6 text-left">
                                <ScrollAnimation 
                                animateIn="fadeInRight"
                                animateOut="fadeInOut"
                                animateOnce={true}>
                                <div className="video-btn">
                                    <img src={`${process.env.PUBLIC_URL + image}` } alt='benefits' width={"400px"}/>
                                </div>
                                </ScrollAnimation>
                        </div>
                    </div>
                </div>
            </div>  
        </div>
    )
}
export default BenefitSection;